import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid } from "@material-ui/core";
import { ModalUtil, SimpleFooterPure } from '../../pures'
import ChangePasswordForm from '../../views/onboarding/steps/changePasswordForm';
import { Auth0Service } from '../../../services'
import atixLogo from '../../../assets/logos/atix-logo.svg'
import "./change-password.css";

/**
 * @param {*} props
 * @return {*} 
 * @status no delete
 * @description Layout of the change password page for user to change the existing password with another.
 */
const ChangePasswordView = (props) => {
    const { token } = props
    const { t } = useTranslation();
    const modalUtil = new ModalUtil()

    const validateChangePassword = async (passwordData) => {
        const auth0Service = new Auth0Service()

        try {
            const { password, confirmPassword } = passwordData

            let passwordValue = password.trim();
            let confirmPasswordValue = confirmPassword.trim();

            // Validate that both passwords are equal
            if (!(passwordValue === confirmPasswordValue)) {
                throw new Error(t("login.action.errorPass"));
            }

            modalUtil.showModal('loading', t("modal.pure.loading.message"), t("modal.pure.loading.title"))
            // Calling service to change password
            let changePassword = await auth0Service.forgotPassword(
                confirmPasswordValue,
                token,
                'internal'
            );
            if (!(Number(changePassword.data.statusCode) === 200)) throw new Error(changePassword.data.message);

            await modalUtil.showModal('success', t("register.updateDataSuccess"), t('modal.pure.title.success'))

            if (changePassword.data.data.redirect) {
                window.location.href = changePassword.data.data.redirect
            } else {
                localStorage.setItem('user-changed-password', true)
                window.location.href = window.location.pathname
            }
        } catch (error) {
            console.log(error)
            modalUtil.showModal('error', error.message || t("register.updateDataError"), t("modal.pure.title.error"))
        }
    }

    return (
        <div className='onboardingView-container'>
            <div className="onboardingView-header">
                <Container style={{ height: '100%' }}>
                    <img alt='Logo de atix' className='onboardingView-logo' src={atixLogo} />
                </Container>
            </div>
            <div className='onboardingView-content' style={{ paddingTop: '100px' }}>
                <Container>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Container maxWidth={false} className='onboardingView-step-content'>
                                <ChangePasswordForm onSubmitStep={validateChangePassword} />
                            </Container>
                        </Grid>
                    </Grid>
                </Container>
            </div>
            <div className="onboardingView-footer">
                <SimpleFooterPure />
            </div>
        </div>
    )
};
export { ChangePasswordView as default };
